import { Component, OnInit } from '@angular/core';

import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { ChangeStatusModalDirective } from '../change-status-modal.directive';
import { Store } from '@ngxs/store';
import { AuctionService, InventoryManagementAuctionItemStatus, LaunchDarklyService } from 'remarketing-angular-library';

@Component({
  selector: 'app-make-removed-modal',
  imports: [TranslocoDirective],
  templateUrl: './make-removed-modal.component.html',
  styleUrl: './make-removed-modal.component.scss'
})
export class MakeRemovedModalComponent extends ChangeStatusModalDirective implements OnInit {

  private textRemoveVehicles: string;
  private textRemoveVehicle: string;
  private textAuctionVehicles: string;
  private textAuctionVehicle: string;
  private textAutobidsVehicles: string;
  private textAutobidsVehicle: string;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.getTranslations();
  }

  get headline() {
    if (this.selectedVehicles.length > 1) {
      return this.textRemoveVehicles;
    } else {
      return this.textRemoveVehicle;
    }
  }

  get modalBody() {
    if (this.selectedVehiclesStatus === InventoryManagementAuctionItemStatus.HOLD) {
      if (this.selectedVehicles.length > 1) {
        return this.textAuctionVehicles;
      } else {
        return this.textAuctionVehicle;
      }
    } else if (this.selectedVehiclesStatus === InventoryManagementAuctionItemStatus.ACTIVE) {
      if (this.selectedVehicles.length > 1) {
        return this.textAutobidsVehicles;
      } else {
        return this.textAutobidsVehicle;
      }
    }
    return '';
  }

  getTranslations() {
    super.getTranslations();
    this.translocoService
      .selectTranslateObject('sellModule.manageInventory.actionListModal.makeRemovedModal')
      .subscribe(translate => {
        this.textRemoveVehicles = translate.textRemoveVehicles;
        this.textRemoveVehicle = translate.textRemoveVehicle;
        this.textAuctionVehicles = translate.textAuctionVehicles;
        this.textAuctionVehicle = translate.textAuctionVehicle;
        this.textAutobidsVehicles = translate.textAutobidsVehicles;
        this.textAutobidsVehicle = translate.textAutobidsVehicle;
      });
  }
}
